//Imports para funcionalidades del mapa
import RouteDetailMap from '../components/RouteDetailMap.vue';

import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';

export default {
  props: ['trip', 'activity', 'showParent', 'badges', 't', 'formatDate', 'gapi'],
  components: { RouteDetailMap, VueperSlides, VueperSlide },
  name: 'RouteDetailDeliveryForm',
  data() {
    return {
      currentTab: null,
      currentImage: null,
      deliveryDate: null,
      sliderLoading: true,
      points: [],
      sliderShowTimeout: 1000,
      mapShowTimeout: 200,
    };
  },
  methods: {
    /**
     * Muestra los puntos de la actividad en el mapa
     */
    async showMapRoute() {
      if (this.points.length > 0) {
        this.showMap = true;
        try {
          this.isBusyMap = false;
          await this.$refs.map.setMultipleMarkers(this.gapi, this.points);

          // await this.$refs.map.getSpotInfoWindow(this.$refs.map.markers[0], 0);
        } catch (e) {
          console.log(e);
          this.showMap = false;
        }
      }
    },
    /**
     * Metodo que maneja el cambio de pestaña segun el valor enviado
     * @param {String} tab
     */
    changeTab(tab) {
      this.currentTab = tab;
      if (this.currentTab === 'galeria' && !this.activity.showOnlyImages) {
        this.changeSliderStyles();
      }
      if (this.currentTab === 'ubicaciones') {
        setTimeout(() => {
          this.showMapRoute();
        }, this.mapShowTimeout);
      }
    },
    /**
     * Cambia los estilos del slider, despues de un periodo infimo de tiempo (ya que no cargan instantaneamente)
     */
    changeSliderStyles() {
      this.sliderLoading = true;
      setTimeout(() => {
        if (!this.activity.images.length) {
          return;
        }

        if (this.activity.images.length > 1) {
          const elements = [
            document.getElementsByClassName('vueperslides__arrow--prev')['0'],
            document.getElementsByClassName('vueperslides__arrow--next')['0'],
          ];

          // Cambio en las flechas
          elements.forEach((element) => {
            element.style.color = 'black';
            element.getElementsByTagName('svg')['0'].style.height = '50px';
            element.getElementsByTagName('svg')['0'].style['stroke-width'] = '2';
          });
        }

        // Cambio en las imagenes mostradas
        [
          ...document.getElementsByClassName('vueperslide cardMain'),
          ...document.getElementsByClassName('vueperslide vueperslide--clone'),
        ].forEach((el) => {
          el.style['background-size'] = 'contain';
          el.style['background-repeat'] = 'no-repeat';
        });
      }, this.sliderShowTimeout / 2);
    },
    /**
     * Metodo que deja de ocultar al slider
     */
    sliderLoaded() {
      if (!this.activity.images.length) {
        this.sliderLoading = false;
      }
      setTimeout(() => {
        this.sliderLoading = false;
      }, this.sliderShowTimeout);
    },
    /**
     * Metodo que permite detectar cuando una slide es cambiada
     * @param {*} event
     */
    slideChange(event) {
      this.currentImage = this.activity.images[event.currentSlide.index];
    },
    /**
     * Metodo que carga los puntos para el mapa segun su existencia en los datos
     */
    loadMapPoints() {
      const destinationPoint = {
        description: this.trip.destinationAddress.street + ', ' + this.trip.destinationAddress.city,
        typeName: this.t('routeDetailModal.deliveryForm.locations.types.destination'),
        type: 'destination',
        coordinates: {
          lat: this.trip.destinationAddress.lat,
          lng: this.trip.destinationAddress.lon,
        },
      };
      this.points.push(destinationPoint);

      if (this.trip.lat && this.trip.lon) {
        const vehiclePoint = {
          typeName: this.t('routeDetailModal.deliveryForm.locations.types.vehicle'),
          type: 'vehicle',
          coordinates: {
            lat: this.trip.lat,
            lng: this.trip.lon,
          },
        };
        this.points.push(vehiclePoint);
      }

      if (this.activity.lat && this.activity.lon) {
        const phonePoint = {
          typeName: this.t('routeDetailModal.deliveryForm.locations.types.phone'),
          type: 'phone',
          coordinates: {
            lat: this.activity.lat,
            lng: this.activity.lon,
          },
        };
        this.points.push(phonePoint);
      }
    },
    /**
     * Metodo que agrega un atributo que contiene la fecha de toma de la foto formateada
     */
    formatImageDates() {
      this.activity.images.forEach((img, index) => {
        this.activity.images[index]['formattedDate'] = img.datePhotoTake
          ? this.formatDate(img.datePhotoTake, 'DD/MM/YYYY HH:mm:ss')
          : null;
      });
    },
    /**
     * Metodo que setea la fecha de entrega de la actividad
     */
    manageDeliveryDate() {
      this.deliveryDate = this.activity.realStartDate
        ? this.formatDate(this.activity.realStartDate, 'DD/MM/YY | HH:mm:ss')
        : this.trip.arrivalDestination.rawReal !== null
        ? this.formatDate(this.trip.arrivalDestination.rawReal, 'DD/MM/YY | HH:mm:ss')
        : this.trip.arrivalDestination.rawSched !== null
        ? this.formatDate(this.trip.arrivalDestination.rawSched, 'DD/MM/YY | HH:mm')
        : '--';
    },
  },
  async created() {
    // Formatea la fecha de las imagenes
    this.formatImageDates();

    // Cambia la tab segun si se muestra solo la galeria o no
    this.currentTab = !this.activity.showOnlyImages ? 'ubicaciones' : 'galeria';

    // Agrega los puntos de esta vista para mostrar en el mapa
    this.loadMapPoints();

    // Calcula la fecha que se mostrara en el formulario
    this.manageDeliveryDate();
  },
  mounted() {
    if (this.activity.showOnlyImages) {
      this.changeSliderStyles();
    } else {
      this.showMapRoute();
    }
  },
  computed: {
    imgContainerSize() {
      return this.activity.showOnlyImages ? 'large' : 'small';
    },
    sliderContainerSize() {
      return this.activity.showOnlyImages ? '500px' : '350px';
    },
  },
};
